import { render, staticRenderFns } from "./Passes.vue?vue&type=template&id=52f66099&scoped=true"
import script from "./Passes.vue?vue&type=script&lang=js"
export * from "./Passes.vue?vue&type=script&lang=js"
import style0 from "./Passes.vue?vue&type=style&index=0&id=52f66099&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f66099",
  null
  
)

export default component.exports